import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56fabec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result" }
const _hoisted_2 = { class: "narrow-container" }
const _hoisted_3 = { class: "result-navigation-section" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import CResultGameInfo from '@/components/CResultGameInfo.vue'
import CResultGamePending from '@/components/CResultGamePending.vue'
import CResultGameLto from '@/components/CResultGameLto.vue'
import CResultGameSkipGame from '@/components/CResultGameSkipGame.vue'
import CResultTable from '@/components/CResultTable.vue'
import { CsFormPreselections, getSubTopic } from '@/lib/customerService'
import { ERROR_CODES } from '@/model/ErrorCodes'


export default /*#__PURE__*/_defineComponent({
  __name: 'MResult',
  props: {
    competitionId: {}
  },
  setup(__props: any) {

const props = __props
const router = useRouter()
const store = useStore()

function created() {
  store.dispatch('results/fetchCompetitionResultById', props.competitionId).catch((err) => {
    if (err && err.errorCode === 401) {
      router.replace('/extern/login')
    } else {
      router.push({
        path: `/error/${(err && err.errorCode) || ERROR_CODES.UNKNOWN}/${store.getters['results/zoneId']}`,
      })
    }
  })
}

const state = computed(() => {
  return store.state.results.current.state
})

function onTournament() {
  router.push('/tournaments/' + store.getters['results/zoneId'])
}

function onPlay(blocked: boolean) {
  if (blocked) {
    return
  }
  const tournamentId = store.getters['results/tournamentId']
  router.push(`/matching/${store.getters['results/zoneId']}/${tournamentId}`)
}

function onCustomerServiceContact() {
  events.$emit('cs-form', {
    topic: 'duelError',
    subTopic: getSubTopic(store.getters['results/zoneId']),
    competitionId: props.competitionId,
  } as CsFormPreselections)
}

created()

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_c_tech_hint = _resolveComponent("c-tech-hint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.value === 'finished')
      ? (_openBlock(), _createBlock(CResultGameInfo, {
          key: 0,
          data: _unref(store).getters['results/ownRanking'],
          "data-qe-id": "game-info"
        }, null, 8, ["data"]))
      : (state.value === 'pending')
        ? (_openBlock(), _createBlock(CResultGamePending, {
            key: 1,
            data: _unref(store).getters['results/ownRanking'],
            "data-qe-id": "game-pending"
          }, null, 8, ["data"]))
        : (state.value === 'skipgame')
          ? (_openBlock(), _createBlock(CResultGameSkipGame, {
              key: 2,
              data: _unref(store).getters['results/ownRanking'],
              onContactCustomerService: onCustomerServiceContact,
              "data-qe-id": "game-skipped"
            }, null, 8, ["data"]))
          : (state.value === 'lto')
            ? (_openBlock(), _createBlock(CResultGameLto, {
                key: 3,
                data: _unref(store).getters['results/ownRanking'],
                "data-qe-id": "game-lto"
              }, null, 8, ["data"]))
            : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(store).state.results.current.nextGame)
          ? (_openBlock(), _createBlock(_component_c_tech_hint, {
              key: 0,
              gametype: _unref(store).state.results.current.gametype,
              techs: _unref(store).getters['results/tournamentSupportedGameTechs']
            }, {
              default: _withCtx((status) => [
                _createVNode(_component_t_button, {
                  inactive: status.block,
                  onClick: ($event: any) => (onPlay(status.block)),
                  yellow: "",
                  "data-qe-id": "play-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('resultView.buttons.play')), 1)
                  ]),
                  _: 2
                }, 1032, ["inactive", "onClick"])
              ]),
              _: 1
            }, 8, ["gametype", "techs"]))
          : _createCommentVNode("", true),
        _createVNode(_component_t_button, {
          onClick: onTournament,
          lightGray: "",
          "data-qe-id": "back-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('resultView.buttons.back')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(CResultTable, {
      data: _unref(store).getters['results/rankingTable'],
      state: state.value,
      "data-qe-id": "ranking-table"
    }, null, 8, ["data", "state"])
  ]))
}
}

})